export enum WebsiteType {
  ACC = 'ACC',
  HARISUMIRAN = 'HARISUMIRAN'
}
